import { useState } from 'react';

const faqs = [
  {
    question: "51吃瓜爆料网的内容来源是否可靠？",
    answer: "我们拥有专业的调查团队和广泛的信息网络，所有爆料内容均经过多渠道交叉验证后发布。对于尚未完全证实的信息，我们会明确标注「待核实」标签，确保读者能够区分事实与传闻。",
  },
  {
    question: "如何向平台提供爆料线索？",
    answer: "您可以通过网站底部的「爆料投稿」按钮或发送邮件至 tips@chigua51.com 提供线索。我们承诺对所有爆料人信息严格保密，并根据线索价值提供相应奖励。",
  },
  {
    question: "网站内容每天更新几次？",
    answer: "我们的编辑团队7×24小时不间断工作，确保第一时间为您带来最新爆料。平均每天更新30-50条内容，重大事件发生时更会实时追踪报道。",
  },
  {
    question: "平台有APP可以下载吗？",
    answer: "目前我们的移动端适配已经非常完善，您可以直接在手机浏览器访问网站获得完整体验。独立APP正在开发中，预计年内上线，敬请期待。",
  },
  {
    question: "如何判断哪些是51吃瓜爆料网的原创独家内容？",
    answer: "所有带有「独家」标签的文章均为我网原创内容，由专业调查团队独立采编。我们鼓励转载但请务必注明出处，共同维护良好的网络内容生态。",
  },
  {
    question: "网站是否需要付费才能查看完整内容？",
    answer: "51吃瓜爆料网始终坚持免费开放的运营理念，所有内容均可免费阅读。我们通过广告和品牌合作维持运营，永远不会向读者收费。",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900">
            常见问题
          </h2>
          <p className="mt-2 text-foreground-500 text-sm">关于51吃瓜爆料网的常见疑问解答</p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-50 border border-background-200 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === idx ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-500 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}